import { axiosInstance } from './axiosInstance'
import { END_POINT_PRODUCT } from './index'
export const deleteAccount = () => {
  return axiosInstance.delete('https://payment.materialorderdesk.com/users/remove')
}

export const getUserSettings = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/user-settings`,
  })
}

export const updateUserSettings = (settings) => {

  const isSample = window.location.pathname.includes('/sample/')  
  if(isSample) {
    console.log('Skipping user settings update for sample user')
    return Promise.resolve() // Return a resolved promise since we're not making an API call
  }

  if (axiosInstance === undefined) {
    console.log('axiosInstance is undefined')
  }

  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/user-settings`,
    data: settings,
  })
}


export const createSampleProject = () => {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/sample-project`,
  })
}